/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { customerCardStyles } from "@insite/content-library/Components/CustomerCard";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

customerCardStyles.container = {
    css: css`
        padding: 15px;
        border-bottom: 1px solid ${getColor("common.border")};

        &:hover,
        &:focus,
        &:active {
            background-color: ${getColor("common.ui7")};
        }
    `,
};

customerCardStyles.addressGridItem = { width: [12, 6, 6, 6, 6] };

customerCardStyles.actionsGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        justify-content: flex-end;
    `,
};

customerCardStyles.selectButton = { variant: "secondary", sizeVariant: "small" };
